import { Link } from "react-router-dom";
import { FaRegCalendarDays } from "react-icons/fa6";
import "./OrderItemStatus.css"

const STATUS_CONFIG = {
    delivered: {
        type: "success",
        title: "Delivered",
        message: "Item delivered successfully",
        showDate: true,
    },
    pending: {
        type: "warning",
        title: "Pending",
        message: "Awaiting confirmation",
    },
    placed: {
        type: "info",
        title: "Order Placed",
        message: "We’ve received your order",
        showDate: true,
    },
    confirmed: {
        type: "info",
        title: "Order Confirmed",
        message: "Your order has been confirmed",
        showDate: true,
    },
    shipped: {
        type: "info",
        title: "Dispatched",
        message: "On the way",
        showDate: true,
    },
    shipment_created: {
        type: "info",
        title: "Shipment Created",
        message: "Preparing for dispatch",
    },
    packed: {
        type: "info",
        title: "Packed",
        message: "Ready for dispatch",
    },
    cancelled: {
        type: "error",
        title: "Cancelled",
        message: "Order has been cancelled",
    },
    replacement_requested: {
        type: "warning",
        title: "Replacement Requested",
        message: "Request submitted",
    },
    replacement_approved: {
        type: "success",
        title: "Replacement Approved",
        message: "Request approved",
    },
    replacement_rejected: {
        type: "error",
        title: "Replacement Rejected",
        message: "Request rejected",
    },
    pickup_scheduled: {
        type: "info",
        title: "Pickup Scheduled",
        message: "Pickup arranged",
        showDate: true,
    },
    picked_up: {
        type: "info",
        title: "Picked Up",
        message: "Item collected",
    },
    replacement_in_progress: {
        type: "info",
        title: "Replacement in Progress",
        message: "Preparing replacement",
    },
    replaced: {
        type: "success",
        title: "Replaced",
        message: "Replacement delivered",
    },
};


const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
    });

const OrderItemStatus = ({ status, deliveredAt }) => {
    const config = STATUS_CONFIG[status] || { title: status };

    return (
        <div className="my-orders-order-item-delivery-info-container">
            <div className={`${status}-info`}>
                <p className="status-status-message">
                    {config.icon} <strong>{config.title}</strong>
                </p>
                {config.message && <p className="status-delivery-message">{config.message}</p>}
                {config.showDate && deliveredAt && (
                    <p className="expected-date">
                        {status === "delivered" ? "Delivered on" : "Expected"}: <FaRegCalendarDays className="calender-icon-my-orders" /> {formatDate(deliveredAt)}
                    </p>
                )}
                {/* {config.contact && (
                    <Link to="/contact" className="status-contact-link">
                        Contact support here 👈
                    </Link>
                )} */}
            </div>
        </div>
    );
};


export default OrderItemStatus